import React from 'react';
import {cn} from '@chekinapp/ui';

const FORM_FIELD_WRAPPER_CLASSES = [
  'form-field-wrapper',
  'relative mx-auto my-0 inline-block w-[275px] text-left',
  '[&:not(:last-child)]:mb-1.5',
  '[@media(max-width:1025px)]:w-full',
  '[@media(max-width:1025px)]:[--field-max-width:100%]',
  '[@media(max-width:1025px)]:[--field-width:100%]',
].join(' ');

type FormFieldWrapperProps = React.ComponentPropsWithoutRef<'div'>;

function FormFieldWrapper({className, ...props}: FormFieldWrapperProps) {
  return <div className={cn(FORM_FIELD_WRAPPER_CLASSES, className)} {...props} />;
}

export {FormFieldWrapper};
export type {FormFieldWrapperProps};
